import { SET_TO_DISABLE_SCREEN } from "../actions/action.types";

const toDisableScreen = (state = false, action: any) => {
  if (action.type === SET_TO_DISABLE_SCREEN) return action.payload;
  else return state;
};

export default toDisableScreen;
